module.exports = __webpack_public_path__ + "assets/img/code.5d75bbee.jpg";